import axios from "axios";
import { config, getDomain, tempAlErr, tempAlWait } from "../helpers";
import { CODE_FILE_DEL, CODE_FILE_DET, CODE_FILE_SAVE } from "./action-types";
import { alertIndex } from "../helpers/alertIndex";

// Détail d'un fichier
export function getCodeFile({idFile}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/code/file/${idFile}`;
        let datas = null;

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (alert.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: CODE_FILE_DET,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("cofldt004");
                dispatch({
                    type: CODE_FILE_DET,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Sauvegarde d'un fichier
export function getCodeFileSave({
    idFile = null,
    name,
    code,
    idFolder
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/code/files/save`;
        if (idFile != null) {
            url += `/${idFile}`;
        }
        let isNext = false;

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred'),
            name: name,
            code: code,
            idFolder: idFolder
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (alert.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: CODE_FILE_SAVE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("coflsa004");
                dispatch({
                    type: CODE_FILE_SAVE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}

// Suppression d'un fichier
export function getCodeFileDelete({
    idFile
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/code/projects/delete/${idFile}`;
        let isNext = false;

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred'),
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (alert.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: CODE_FILE_DEL,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("cofldl004");
                dispatch({
                    type: CODE_FILE_DEL,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}